// import React, { useState, useEffect } from 'react';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../helpers/authContext';
import { useParams, useNavigate, useLocation } from "react-router-dom";   
import { fetchUser } from './userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setSteemConfig } from 'config';
import { RootState } from 'app/store/rootReducer';
import { get_plans, get_user_directories  } from 'services/db-service'; 
import FollowButton from 'components/FollowButton';
import { getReputation, getSteemMarketCondition, isLoggedWithKeychain, numberWithCommas, steemCustomApi } from 'services/dsteem-service';
import { SEO } from 'components/SEO'; 
import { VerifiedIcon } from 'components/VerifiedIcon';
import { useToast } from 'components/ui/use-toast';  
import { claimWithWif, changePasswordWithWif, tokenToBalance, vests2SP } from 'helpers/steem';
import { getRemainingTime } from 'services/posts-service';
import { claimKeychain } from 'helpers/keychain';
import useModal from 'helpers/useModal';
import TransferModal from './userModals/TransferModal';
import TransferToVestingModal from './userModals/TransferToVestingModal';
import DelegateModal from './userModals/DelegateModal';
import PowerDownModal from './userModals/PowerDownModal';
import LoginModal from './userModals/LoginModal';
import TransferToSavingsModal from './userModals/TransferToSavings';
import WithdrawFromSavingsModal from './userModals/WithdrawFromSavingsModal';
import CancelWithdrawFromSavingsModal from './userModals/CancelWithdrawFromSavingsModal';
import GenerateLinkModal from './userModals/GenerateLinkModal';
import { PrivateKey } from 'dsteem';
import { extractSessionData } from 'helpers/localStorage';
import { UserHistorySection } from './UserHistorySection';
import UserMarketTab from './UserMarketTab';
import { 
  Card, CardBody, FormGroup, Label, Input, Alert, Button
} from "reactstrap";
import Skeleton from 'react-loading-skeleton';

export const UserWallet  = (params:any) => { 
    const { toast } = useToast();
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const { username, tab } = useParams(); 
    const { user, rpc_node, autologin  } = useAuth(); 
    const [transferSymbol, setTransferSymbol] = useState<any>("STEEM");
    const [activeTab, setActiveTab] = React.useState(tab || params.tab || 'balance');   
    const [profileData, setProfileData] = useState<{name?: string, about?: string, avatar?: string, cover?: string}>({});  

    const [urlOp, setUrlOp] = useState<string>("");
    const [urlTo, setUrlTo] = useState<string>("");
    const [urlAmount, setUrlAmount] = useState<any>("");

    const [urlMemo, setUrlMemo] = useState<string>("");
    const [urlAutoConfirm, setUrlAutoConfirm] = useState<boolean>(false);

    const {
        userData, 
        isLoading,
        error
    } = useSelector((state: RootState) => state.userData);
    const location = useLocation();
    const [userPlans, setUserPlans] = useState([]);
    const [userDirectories, setUserDirectories] = useState([]);
    const [mvest, setMVest] = useState(0);
    const [steemPrice, setSteemPrice] = useState(0);
    const [spAPR, setSpAPR] = useState(0);
    const [sbdPrice, setSBDPrice] = useState(0);
    const [isClaiming, setIsClaiming] = useState(false);
    const [fullMarket, setFullMarket] = useState<any>(false);  
    const [cancelPD, setCancelPD] = useState(false); 
    const [requestIdToCancel, setRequestIdToCancel] = useState(false); 
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [showFullKeys, setShowFullKeys] = useState(false);
    const [masterPass, setMasterPass] = useState("");
    const [fullKeysData, setFullKeysData] = useState<any>(null);
    // Change password state
    const [cpCurrentPass, setCpCurrentPass] = useState("");
    const [cpNewPass, setCpNewPass] = useState("");
    const [cpConfirmPass, setCpConfirmPass] = useState("");
    const [cpChecked, setCpChecked] = useState(false);
    const [cpSaved, setCpSaved] = useState(false);
    const [cpLoading, setCpLoading] = useState(false);
    const [cpGenerated, setCpGenerated] = useState("");
    const keychainLogin = isLoggedWithKeychain(autologin);
    const { isOpenTransferModal, toggleTransferModal, isOpenTransferToVestingModal, toggleTransferToVestingModal, 
        isOpenDelegateModal, toggleDelegateModal, isOpenPowerDownModal, togglePowerDownModal, isOpenLoginModal, toggleLoginModal,
        toggleTransferToSavingsModal, isOpenTransferToSavingsModal, toggleWithdrawFromSavingsModal, isOpenWithdrawFromSavingsModal,
        toggleCancelWithdrawFromSavingsModal, isOpenCancelWithdrawFromSavingsModal, isOpenGenerateLinkModal, toggleGenerateLinkModal
     } = useModal();
    const onNewError = (message) => {
        setErrorMessage(message); 
        setTimeout(() => { setErrorMessage(null); }, 15000);
    } 
    useEffect(() => {
        if (!username && user) {
            navigate(`/wallet/${user}${location.search}`, { replace: true });
        }
    }, [username, user, location.search]);

    useEffect(() => {
        if (!user) return; // Wait until logged in
        const paramsStr = location.search;
        if (!paramsStr) return;

        const searchParams = new URLSearchParams(paramsStr);
        const op = searchParams.get('op');
        if (op) {
            const to = searchParams.get('to') || "";
            const amount = searchParams.get('amount') || "";
            const currency = searchParams.get('currency') || "STEEM";
            const memo = searchParams.get('memo') || "";

            setUrlTo(to);
            setUrlAmount(amount ? parseFloat(amount) : "");
            setUrlMemo(memo);
            setUrlAutoConfirm(true); // Auto-confirm when loaded from URL

            if (op === 'transfer') {
                setTransferSymbol(currency);
                if (!isOpenTransferModal) toggleTransferModal();
            } else if (op === 'transferToVesting') {
                if (!isOpenTransferToVestingModal) toggleTransferToVestingModal();
            } else if (op === 'delegateVestingShares') {
                if (!isOpenDelegateModal) toggleDelegateModal();
            }

            // Remove URL params to avoid re-triggering on refresh
            navigate(location.pathname, { replace: true });
        }
    }, [location.search, user]);

    useEffect(() => {
        const currentTab = tab || params.tab || 'balance';
        if (currentTab !== activeTab) {
            setActiveTab(currentTab);
        }
    }, [tab, params.tab]);

    const handleTabChange = (newTab: string) => {
        if (username) {
            navigate(`/wallet/${username}/${newTab}`);
        }
        setActiveTab(newTab);
    };

    const calculateSPApr = (globals: any) => {
        if (!globals) return 0;
        const headBlock = Number(globals.head_block_number);
        const virtualSupply = parseFloat(globals.virtual_supply);
        const totalVestingFund = parseFloat(globals.total_vesting_fund_steem);
        const vestingRewardPercent = Number(globals.vesting_reward_percent);
        const inflationRate = (978 - headBlock / 250000) / 100;
        const apr = (virtualSupply * inflationRate * vestingRewardPercent) / totalVestingFund / 10000;
        return Number(apr.toFixed(2));
    };

    const get_blockchain_data = async () => {
        try {
            // First, fetch standard market prices (more reliable for USD display)
            let full_market = await getSteemMarketCondition(); 
            if (full_market) {
                if (full_market['steem-dollars']) full_market.sbd = full_market['steem-dollars'];
                setFullMarket(full_market);
                // Set initial prices from market data
                if (full_market.steem?.usd) setSteemPrice(full_market.steem.usd);
                if (full_market.sbd?.usd) setSBDPrice(full_market.sbd.usd);
            }

            const globals = await steemCustomApi("condenser_api.get_dynamic_global_properties", []);
            const witnesses = await steemCustomApi("condenser_api.get_witnesses_by_vote", [null, 20]); 
            const market = await steemCustomApi("market_history_api.get_recent_trades", {limit: 10});

            if (!globals || !witnesses) return;

            setSpAPR(calculateSPApr(globals));
            var per_mvest = parseFloat(globals.total_vesting_fund_steem) * 1000000 / parseFloat(globals.total_vesting_shares);
            setMVest(per_mvest);

            // Fetch witness-based STEEM price as fallback/internal reference
            let rates = 0;
            for (let i = 0; i < witnesses.length; i++) {
                rates += parseFloat(witnesses[i].sbd_exchange_rate.base) || 0; 
            }
            if (witnesses.length > 0) {
                let witness_steem_price = parseFloat((rates / witnesses.length).toFixed(3));
                // Only update if we don't have a market price yet or to keep sync
                setSteemPrice(prev => prev || witness_steem_price);
            }

            if (market && market.trades && market.trades.length > 0) {
                let sbd_rate = 0;
                for (let i = 0; i < market.trades.length; i++) {
                    const element = market.trades[i];
                    let paid = tokenToBalance(element.current_pays, per_mvest);
                    let received = tokenToBalance(element.open_pays, per_mvest);
                    let base = (paid.includes("SBD")) ? (parseFloat(received) / parseFloat(paid)) : (parseFloat(paid) / parseFloat(received)); 
                    sbd_rate += base;
                }
                let avg_sbd_rate = (sbd_rate / market.trades.length) * (full_market?.steem?.usd || 0.20);
                setSBDPrice(prev => prev || parseFloat(avg_sbd_rate.toFixed(3))); 
            }
        } catch (error) {
            console.log("While getting blockchain data", error);
        } 
    }

    useEffect(() => {
        if (activeTab === 'balance' && username) {
            dispatch(fetchUser(username, false));
            get_blockchain_data();
        }
    }, [activeTab, username]);

    // Scroll feature 
    useEffect(() => {
        if (!location.pathname.startsWith('/wallet')) return;
        if (userData && userData?.posting_json_metadata) {
            try {
                const metadata = (userData.posting_json_metadata === "undefined" || !userData.posting_json_metadata) ? null : JSON.parse(userData.posting_json_metadata);
                if (!metadata) {
                    throw "Error parsing";
                }
                const profile = metadata.profile || {}; 
                let it = {
                name: (profile.name || "") + ` (@${username})` || username,
                about: profile.about || `Profile of ${username} on Speak on Steem`,
                avatar: profile.avatar || `https://steemitimages.com/u/${username}/avatar`,
                cover: profile.cover_image || ""
                }
                setProfileData(it); 
                
            } catch (e) {
                console.log("Error parsing profile metadata", e);
                setProfileData({
                name: username,
                about: `Profile of ${username} on Speak on Steem`,
                avatar: `https://steemitimages.com/u/${username}/avatar`,
                cover: ""
                });
            }
        } else {
            setProfileData({
                name: username,
                about: `Profile of ${username} on Speak on Steem`,
                avatar: `https://steemitimages.com/u/${username}/avatar`,
                cover: ""
            });
        }
    }, [userData, username, location.pathname]); 

    useEffect(() => {
        if (!location.pathname.startsWith('/wallet')) return;
        if (!username) return; 
        setSteemConfig(rpc_node);
        dispatch(fetchUser(username));  
    }, [dispatch, username, rpc_node]); 
    const getUserDirectories = async () => { 
        let data = await get_user_directories(user); 
        setUserDirectories(data); 
    }
    useEffect(() => { 
        if (!location.pathname.startsWith('/wallet')) return;
        window.scrollTo(0, 0);
        if (!username && !user) return;
        const getPlans = async () => { 
            let data = await get_plans(); 
            setUserPlans(data); 
        }
        getPlans();  
        getUserDirectories(); 
        get_blockchain_data();
    }, [location.pathname]); 

     

    const handleClaim = async (steem, sp, sbd ) => {  
        const fn = keychainLogin ? claimKeychain : claimWithWif;
        const account = keychainLogin ? user : autologin; 
        setIsClaiming(true);
        let res:any = await fn(account, steem, sp, sbd);
        setIsClaiming(false);
        if (!res.success) {
            console.log(res); 
            if(res?.message?.toString()?.includes("Missing Active Authority")){ 
                toast({
                    title:"Failed claiming. Missing authority",
                    description:res.message,
                    variant:"rose_red"
                });
                return;
            }
            
            toast({
            title:"Failed claiming rewards.",
            description:res.message,
            variant:"rose_red"
            });
        }else {
            toast({
            title:"Rewards claimed successfully.",
            description:"Balances are being refreshed…",
            variant:"wild_green"
            });
            dispatch(fetchUser(username, false));
            setTimeout(() => {
                dispatch(fetchUser(username, false));
            }, 3000); 
        } 
        
    } 
    let profileHeader; 
    let userCover; 
    if (userData && Object.keys(userData).length > 0) {   
        let profile = null;
        try { 
            profile = (userData.posting_json_metadata === "undefined" || !userData.posting_json_metadata) ? null : (JSON.parse(userData.posting_json_metadata)?.profile) || null; 
        } catch (error) {
            console.log("While getting profile", error); 
        }  
        if (profile && profile.cover_image) {
            userCover = ( 
                <div className="cover-container" style={{ width: "100%", height: "220px", overflow: "hidden" }}>
                    <img src={profile.cover_image} alt='Cover' className='profile-cover' />
                    <div className="profile-cover-gradient"></div>
                    <div className="profile-floating-buttons">
                        {user && user !== username && (
                            <FollowButton author={username} className='mr-2' onError={onNewError} />
                        )} 
                        {user && user == username && (
                            <button className="btn btn-default mr-2" onClick={()=>{
                                navigate("/settings")
                            }}>
                                <i className="fas fa-cog" />
                            </button>
                        )}
                        <button className="btn btn-default mr-2" onClick={()=>{ navigate(`/u/${username}`) }}>
                            <i className="fas fa-user" />
                        </button>
                        {/* <button className="btn btn-default">
                            <i className="fas fa-share" />
                        </button> */}
                    </div> 
                </div> 
            );
        } else { 
            userCover = (
                <div className="cover-container" style={{ width: "100%", height: "220px", overflow: "hidden"}}> 
                    <div className="profile-floating-buttons">
                        {user && user !== username && (
                            <FollowButton author={username} className='mr-2' onError={onNewError} />
                        )}  
                        {user && user == username && (
                            <button className="btn btn-default mr-2" onClick={()=>{
                                navigate("/settings")
                            }}>
                                <i className="fas fa-cog" />
                            </button>
                        )} 
                        <button className="btn btn-default mr-2" onClick={()=>{ navigate(`/u/${username}`) }}>
                            <i className="fas fa-user" />
                        </button>
                    </div> 
                </div> 
            );
        }
        const plan = userPlans.find(u => u.username === username);  
        let isPlus = plan?.plan_type?.includes("plus") || false;
        profileHeader = (
            <> 
            <div className="row profile-container d-flex p-2"> 
                <div className="col-12 col-sm-12 col-md-3 col-lg-auto text-center text-sm-center text-md-left">
                    <div className="profile-image-container">
                        <img
                            src={`https://steemitimages.com/u/${username}/avatar`}
                            alt="Profile"
                            className="profile-image"
                        />
                    </div> 
                </div> 

                <div className="col-12 col-sm-12 col-md-9  col-lg-auto text-center text-sm-center text-md-left"> 
                    <div className="d-inline-block">
                        <div className="d-flex">
                            <h3 className={`fw-bold me-3 m-0 ${(userCover)?"color-md-white":""}`}>{(profile && profile.name)?profile.name:username} ({getReputation(userData.reputation)}) {(isPlus) && (<div className="text-muted d-inline-block"  title='Verified Plus member.' style={{marginRight:"2px", cursor:"pointer"}}><VerifiedIcon size={30} className="color-speem" /> </div> )} <div className="profile-name text-muted">{(profile && profile.name)?`· ${username}`: ""}</div></h3>  
                        </div>  
                    </div>
                    <div className="mb-4 fw-semibold">
                        <span className="cursor-pointer" ><strong className={`${(userCover)?"color-md-white":""}`}>{numberWithCommas(userData?.followers_count?.following_count || 0)}</strong> <span className="text-muted">Following</span></span>
                        <span className="cursor-pointer ml-2" ><strong className={`${(userCover)?"color-md-white":""}`}>{numberWithCommas(userData?.followers_count?.follower_count || 0)}</strong> <span className="text-muted">Followers</span></span>
                        <span className="cursor-pointer ml-2"><strong className={`${(userCover)?"color-md-white":""}`}>{numberWithCommas(userData?.views_count?.views || 0)}</strong> <span className="text-muted">Views</span></span>
                    </div>  
                    <div className="profile-about text-muted mb-1">{(profile && profile.about)?profile.about:""}</div>
                    {(profile && profile.website) && (
                        <a href={profile.website} className="color-orange" target="_blank" rel="noreferrer">
                            <i className="fas fa-link" /> {profile.website}
                        </a> 
                    )}
                    
                </div> 

            </div> 
            </>
        );
    } else if (isLoading) {
        profileHeader = (
            <div className="row profile-container d-flex p-2">
                <div className="col-12 col-sm-12 col-md-3 col-lg-auto text-center text-sm-center text-md-left">
                    <div className="profile-image-container">
                        <Skeleton circle={true} height={120} width={120} />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-9 col-lg-auto text-center text-sm-center text-md-left">
                    <div className="d-inline-block">
                        <Skeleton width={250} height={30} className="mb-2" />
                    </div>
                    <div className="mb-4">
                        <Skeleton width={300} height={20} />
                    </div>
                    <div className="profile-about mb-1">
                         <Skeleton width={400} height={20} />
                    </div>
                    <div className="mt-1">
                        <Skeleton width={150} height={15} />
                    </div>
                </div>
            </div>
        );
    }
    const renderBalances = () => { 
        if(isLoading && (!userData || Object.keys(userData).length === 0)){ 
            return (
                <div className="row w-100 m-0">
                    {[1, 2, 3, 4].map(i => (
                        <div key={i} className="col-xs-12 col-sm-6 col-md-6 col-lg-4 p-2">
                            <div className="speem-gray balance-content p-3" style={{minHeight: "180px"}}>
                                <div className="balance-content-header d-flex align-items-center">
                                    <Skeleton circle={true} height={40} width={40} className="mr-2" />
                                    <div style={{flex: 1}}>
                                        <Skeleton width="60%" height={20} />
                                        <Skeleton width="40%" height={12} />
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <Skeleton width="80%" height={35} />
                                    <Skeleton width="50%" height={15} className="mt-2" />
                                </div>
                                <div className="balance-actions-row">
                                    <div className="action-item"><Skeleton circle height={48} width={48} /><Skeleton width={40} height={10} className="mt-1" /></div>
                                    <div className="action-item"><Skeleton circle height={48} width={48} /><Skeleton width={40} height={10} className="mt-1" /></div>
                                    <div className="action-item"><Skeleton circle height={48} width={48} /><Skeleton width={40} height={10} className="mt-1" /></div>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 p-2">
                         <div className="speem-gray balance-content p-3" style={{minHeight: "180px"}}>
                            <Skeleton height={20} width="30%" className="mb-3" />
                            <div className="market-horizontal-item">
                                <Skeleton circle height={40} width={40} className="mr-3" />
                                <div className="flex-grow-1"><Skeleton height={20} width="30%" /><Skeleton height={12} width="15%" /></div>
                                <div className="text-right mr-4"><Skeleton height={25} width={80} /><Skeleton height={15} width={50} /></div>
                                <div className="market-item-stats-col"><Skeleton height={50} width={120} /></div>
                            </div>
                            <div className="market-horizontal-item">
                                <Skeleton circle height={40} width={40} className="mr-3" />
                                <div className="flex-grow-1"><Skeleton height={20} width="30%" /><Skeleton height={12} width="15%" /></div>
                                <div className="text-right mr-4"><Skeleton height={25} width={80} /><Skeleton height={15} width={50} /></div>
                                <div className="market-item-stats-col"><Skeleton height={50} width={120} /></div>
                            </div>
                         </div>
                    </div>
                </div>
            )
        } 
        const currentSteemPrice = fullMarket?.steem?.usd || steemPrice || 0;
        const currentSBDPrice = fullMarket?.sbd?.usd || sbdPrice || 0;

        let steem = parseFloat(userData.balance) || 0;
        let steem_usd_value = steem * currentSteemPrice;
        let steem_savings = parseFloat(userData.savings_balance) || 0;
        let steem_savings_usd = steem_savings * currentSteemPrice;
        let sbd = parseFloat(userData.sbd_balance) || 0;
        let sbd_savings = parseFloat(userData.savings_sbd_balance) || 0;
        let sbd_savings_usd = sbd_savings * currentSBDPrice;
        let sbd_usd_value = sbd * currentSBDPrice;
        let withdraw_savings_requests = userData.savings_withdraw_requests_list || [];
        
        let sp = vests2SP(userData.vesting_shares, mvest) || 0;
        let sp_usd_value = sp * currentSteemPrice;
        let delegated = vests2SP(userData.delegated_vesting_shares, mvest) || 0;
        let received = vests2SP(userData.received_vesting_shares, mvest) || 0;
        let pd = vests2SP(userData.vesting_withdraw_rate, mvest) || 0;
        let pd_usd = pd * currentSteemPrice;
        
        let totalSP = parseFloat((sp - delegated - pd + received).toFixed(3)) || 0;

        let steem_to_claim = parseFloat(userData.reward_steem_balance) || 0;
        let sbd_to_claim = parseFloat(userData.reward_sbd_balance) || 0;
        let sp_to_claim = vests2SP(userData.reward_vesting_balance, mvest) || 0;
        let new_rewards_usd = ((steem_to_claim + sp_to_claim) * currentSteemPrice) + (sbd_to_claim * currentSBDPrice) || 0;
        
        let nextVestingWithdrawString = getRemainingTime(userData.next_vesting_withdrawal); 
        
        return (
            <> 
            {user == username && new_rewards_usd > 0 && (
                <div className="col-12 p-2" >
                    <div className="speem-gray balance-content p-3">  
                        <div className="balance-content-value balance-claim-row ">
                            <div className="balance-claim-info">
                                <div className="balance-amount">
                                You have new rewards to claim:
                                {steem_to_claim > 0 && (
                                    <>
                                    <span className="ml-2 balance-number">
                                        {numberWithCommas(steem_to_claim.toFixed(3))}
                                    </span>
                                    <span className="balance-currency"> STEEM</span>
                                    </>
                                )}
                                {sbd_to_claim > 0 && (
                                    <>
                                    <span className="ml-2 balance-number">
                                        {numberWithCommas(sbd_to_claim.toFixed(3))}
                                    </span>
                                    <span className="balance-currency"> SBD</span>
                                    </>
                                )}
                                {sp_to_claim > 0 && (
                                    <>
                                    <span className="ml-2 balance-number">
                                        {numberWithCommas(sp_to_claim.toFixed(3))}
                                    </span>
                                    <span className="balance-currency"> SP</span>
                                    </>
                                )}
                                </div>

                                <div className="sp-stats-row mt-1">
                                    <div className="sp-stat-pill usd">
                                        <i className="fas fa-dollar-sign" /> {numberWithCommas(new_rewards_usd.toFixed(2))}
                                    </div>
                                </div>
                            </div> 
                                <button className="btn btn-speem btn-claim" style={{minWidth:"100px"}} onClick={() => handleClaim(userData.reward_steem_balance, userData.reward_vesting_balance, userData.reward_sbd_balance)}>
                                    <i className="fas fa-coins" /> {isClaiming? <span className="spinner dark m-0" />:"Claim"}
                                </button> 
                            
                        </div>
                    </div>
                </div>
            )} 
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 p-2" >
                <div className="speem-gray balance-content p-3">
                    <div className="balance-content-header">
                        <img src="/assets/img/steem.webp" className="balance-icon mr-2" />

                        <span className="balance-title">
                            <span className="balance-title-main">STEEM</span>
                            <span className="balance-title-sub text-muted">Liquid value</span>
                        </span>
                        {user == username && (
                            <div className="ml-auto">
                                <i className="fas fa-link cursor-pointer text-muted" title="Generate Link" onClick={() => { setUrlOp("transfer"); setTransferSymbol("STEEM"); toggleGenerateLinkModal(); }} />
                            </div>
                        )}
                    </div>
                    <div className="balance-content-value mt-2">
                        <div className='balance-amount'>
                            <span className='balance-number'>{numberWithCommas(steem.toFixed(3))}</span> <span className='balance-currency'>STEEM</span>
                        </div> 
                        <div className="sp-stats-row mt-2">
                            <div className="sp-stat-pill usd">
                                <i className="fas fa-dollar-sign" /> {numberWithCommas(steem_usd_value.toFixed(2))}
                            </div>
                        </div>
                    </div>
                    {user == username && (
                        <div className="balance-actions-row">
                            <div className="action-item" onClick={()=>{setTransferSymbol("STEEM");toggleTransferModal();}} title="Send STEEM">
                                <div className="action-button-circle"><i className="fas fa-paper-plane" /></div>
                                <span className="action-label">Send</span>
                            </div>
                            <div className="action-item" onClick={toggleTransferToVestingModal} title="Power up STEEM">
                                <div className="action-button-circle"><i className="fas fa-bolt" /></div>
                                <span className="action-label">Power Up</span>
                            </div>
                            <div className="action-item" onClick={()=>handleTabChange('market')} title="Trade STEEM">
                                <div className="action-button-circle"><i className="fas fa-right-left" /></div>
                                <span className="action-label">Trade</span>
                            </div>
                            <div className="action-item" onClick={()=>{setTransferSymbol("STEEM");toggleTransferToSavingsModal();}} title="Move to Savings">
                                <div className="action-button-circle"><i className="fas fa-vault" /></div>
                                <span className="action-label">Save</span>
                            </div>
                        </div>
                    )}
                    
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 p-2" >
                <div className="speem-gray balance-content p-3">
                    <div className="balance-content-header">
                        <img src="/assets/img/sbd.webp" className='balance-icon mr-2' />
                        <span className="balance-title">
                            <span className="balance-title-main">SBD</span>
                            <span className="balance-title-sub text-muted">Steem Dollars • Stable coin</span>
                        </span>
                        {user == username && (
                            <div className="ml-auto">
                                <i className="fas fa-link cursor-pointer text-muted" title="Generate Link" onClick={() => { setUrlOp("transfer"); setTransferSymbol("SBD"); toggleGenerateLinkModal(); }} />
                            </div>
                        )}
                    </div>
                    <div className="balance-content-value mt-2">
                        <div className='balance-amount'>
                            <span className='balance-number'>{numberWithCommas(sbd.toFixed(3))}</span> <span className='balance-currency'>SBD</span>
                        </div>
                        <div className="sp-stats-row mt-2">
                            <div className="sp-stat-pill usd">
                                <i className="fas fa-dollar-sign" /> {numberWithCommas((sbd_usd_value).toFixed(2))}
                            </div>
                        </div>
                    </div>
                    {user == username && (
                        <div className="balance-actions-row">
                            <div className="action-item" onClick={()=>{setTransferSymbol("SBD");toggleTransferModal();}} title="Send SBD">
                                <div className="action-button-circle"><i className="fas fa-paper-plane" /></div>
                                <span className="action-label">Send</span>
                            </div>
                            <div className="action-item" onClick={()=>handleTabChange('market')} title="Trade SBD">
                                <div className="action-button-circle"><i className="fas fa-right-left" /></div>
                                <span className="action-label">Trade</span>
                            </div>
                            <div className="action-item" onClick={()=>{setTransferSymbol("SBD");toggleTransferToSavingsModal();}} title="Move to Savings">
                                <div className="action-button-circle"><i className="fas fa-vault" /></div>
                                <span className="action-label">Save</span>
                            </div>
                        </div>
                    )}
                    
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 p-2" >
                <div className="speem-gray balance-content p-3">
                    <div className="balance-content-header">
                        <img src="/assets/img/sp.webp" className='balance-icon mr-2' />
                        <span className="balance-title">
                            <span className="balance-title-main">Steem Power</span>
                            <span className="balance-title-sub text-muted">Voting resource • ≈ {spAPR}% APR</span>
                        </span>
                        {user == username && (
                            <div className="ml-auto">
                                <i className="fas fa-link cursor-pointer text-muted" title="Generate Link" onClick={() => { setUrlOp("delegateVestingShares"); toggleGenerateLinkModal(); }} />
                            </div>
                        )}
                    </div>
                    <div className="balance-content-value mt-2">
                        <div className='balance-amount'>
                            <span className='balance-number'>{(numberWithCommas(totalSP.toFixed(3)) || 0.000)}</span> <span className='balance-currency'>SP</span>
                            
                        </div>  
                        <div className="sp-stats-row text-muted">
                            <div className="sp-stat-pill" title="Owned SP">
                                <i className="fas fa-user" /> {numberWithCommas(sp.toFixed(2))}
                            </div>
                            {received > 0 && (
                                <div className="sp-stat-pill received" title="Received Delegations">
                                    <i className="fas fa-arrow-down" /> {numberWithCommas(received.toFixed(2))}
                                </div>
                            )}
                            {delegated > 0 && (
                                <div className="sp-stat-pill delegated" title="Outgoing Delegations">
                                    <i className="fas fa-arrow-up" /> {numberWithCommas(delegated.toFixed(2))}
                                </div>
                            )}
                            {pd > 0 && (
                                <div className="sp-stat-pill pd" title="Powering Down">
                                    <i className="fas fa-power-off" /> {numberWithCommas(pd.toFixed(2))}
                                </div>
                            )}
                            <div className="sp-stat-pill usd" title="Estimated Value in USD">
                                <i className="fas fa-dollar-sign" /> {numberWithCommas(sp_usd_value.toFixed(2))}
                            </div>
                        </div>
                    </div>
                    {user == username && (
                        <div className="balance-actions-row">
                            <div className="action-item" onClick={toggleDelegateModal} title="Delegate Steem Power">
                                <div className="action-button-circle"><i className="fas fa-hand-holding-heart" /></div>
                                <span className="action-label">Delegate</span>
                            </div>
                            <div className="action-item" onClick={()=>{setCancelPD(false);togglePowerDownModal();}} title="Start Power Down">
                                <div className="action-button-circle"><i className="fas fa-power-off" /></div>
                                <span className="action-label">Power Down</span>
                            </div>
                        </div>
                    )}
                    
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 p-2" >
                <div className="speem-gray balance-content p-3">
                    <div className="balance-content-header">
                        <img src="/assets/img/savings.png" className="balance-icon mr-2" />
                        <span className="balance-title">
                            <span className="balance-title-main">Savings Balance</span>
                            <span className="balance-title-sub text-muted">3-Day Protected Funds</span>
                        </span>
                        {user == username && (
                            <div className="action-item ml-auto" onClick={toggleWithdrawFromSavingsModal} title="Withdraw from Savings" style={{minWidth: 'auto', marginTop:"-5px", marginBottom:"-5px"}}>
                                <div className="action-button-circle" style={{width: '32px', height: '32px', marginBottom: '2px', fontSize: '0.9rem'}}>
                                    <i className="fas fa-arrow-up-from-bracket" />
                                </div>
                                <span className="action-label" style={{fontSize: '0.6rem'}}>Withdraw</span>
                            </div>
                        )}
                    </div>
                    <div className="balance-content-value mt-2 d-flex flex-column" style={{gap: '15px'}}>
                        <div style={{borderBottom: "1px solid rgba(0,0,0,0.05)", paddingBottom: "10px"}}>
                            <div className='balance-amount'>
                                <span className='balance-number'>{(numberWithCommas(steem_savings.toFixed(3)) || 0.000)}</span> <span className='balance-currency'>STEEM</span>
                            </div>  
                            <div className="sp-stats-row mt-1">
                                <div className="sp-stat-pill usd">
                                    <i className="fas fa-dollar-sign" /> {numberWithCommas(steem_savings_usd.toFixed(2))}
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className='balance-amount'>
                                <span className='balance-number'>{(numberWithCommas(sbd_savings.toFixed(3)) || 0.000)}</span> <span className='balance-currency'>SBD</span>
                            </div>  
                            <div className="sp-stats-row mt-1">
                                <div className="sp-stat-pill usd">
                                    <i className="fas fa-dollar-sign" /> {numberWithCommas(sbd_savings_usd.toFixed(2))}
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </div>
            </div>
            {fullMarket && (<div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 p-2" >
                <div className="speem-gray balance-content p-3">
                    <div className="market-items-list">
                        <div className="market-horizontal-item">
                            <img src="/assets/img/steem.webp" className="market-item-icon" />
                            <div className="market-item-main">
                                <span className="market-item-name">STEEM</span>
                                <span className="market-item-symbol text-muted">Native Token</span>
                            </div>
                            <div className="market-item-price-col">
                                <span className="market-item-price">${numberWithCommas(fullMarket?.steem?.usd?.toFixed?.(3) || "0.000")}</span>
                                <span className={`market-item-change ${(fullMarket?.steem?.usd_24h_change || 0) > 0 ? "price-up" : "price-down"}`}>
                                    <i className={`fas fa-${(fullMarket?.steem?.usd_24h_change || 0) > 0 ? "caret-up" : "caret-down"} mr-1`} />
                                    {(fullMarket?.steem?.usd_24h_change || 0) > 0 ? `+${(fullMarket?.steem?.usd_24h_change || 0).toFixed(2)}` : (fullMarket?.steem?.usd_24h_change || 0).toFixed(2)}%
                                </span>
                            </div>
                            <div className="market-item-stats-col d-none d-md-block">
                                <div className="market-stat-row">
                                    <span className="market-stat-label">Vol (24h)</span>
                                    <span className="market-stat-value">${numberWithCommas(fullMarket?.steem?.usd_24h_vol?.toFixed?.(0) || "0")}</span>
                                </div>
                                <div className="market-stat-row">
                                    <span className="market-stat-label">MCap</span>
                                    <span className="market-stat-value">${numberWithCommas(fullMarket?.steem?.usd_market_cap?.toFixed?.(0) || "0")}</span>
                                </div>
                            </div>
                        </div>
                        <div className="market-horizontal-item">
                            <img src="/assets/img/sbd.webp" className="market-item-icon" />
                            <div className="market-item-main">
                                <span className="market-item-name">SBD</span>
                                <span className="market-item-symbol text-muted">Steem Dollar</span>
                            </div>
                            <div className="market-item-price-col">
                                <span className="market-item-price">${numberWithCommas(fullMarket?.sbd?.usd?.toFixed?.(3) || "0.000")}</span>
                                <span className={`market-item-change ${(fullMarket?.sbd?.usd_24h_change || 0) > 0 ? "price-up" : "price-down"}`}>
                                    <i className={`fas fa-${(fullMarket?.sbd?.usd_24h_change || 0) > 0 ? "caret-up" : "caret-down"} mr-1`} />
                                    {(fullMarket?.sbd?.usd_24h_change || 0) > 0 ? `+${(fullMarket?.sbd?.usd_24h_change || 0).toFixed(2)}` : (fullMarket?.sbd?.usd_24h_change || 0).toFixed(2)}%
                                </span>
                            </div>
                            <div className="market-item-stats-col d-none d-md-block">
                                <div className="market-stat-row">
                                    <span className="market-stat-label">Vol (24h)</span>
                                    <span className="market-stat-value">${numberWithCommas(fullMarket?.sbd?.usd_24h_vol?.toFixed?.(0) || "0")}</span>
                                </div>
                                <div className="market-stat-row">
                                    <span className="market-stat-label">MCap</span>
                                    <span className="market-stat-value">${numberWithCommas(fullMarket?.sbd?.usd_market_cap?.toFixed?.(0) || "0")}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>)}
            {pd > 0 && (
                <div className="col-12 p-2" >
                    <div className="outline-red balance-content p-3">  
                        <div className="balance-content-value balance-claim-row ">
                            <div className="balance-claim-info">
                                <div className="balance-amount">
                                You have an active power down:
                                {pd > 0 && (
                                    <>
                                    <span className="ml-2 balance-number">
                                        {numberWithCommas(pd.toFixed(3))}
                                    </span>
                                    <span className="balance-currency"> STEEM</span>
                                    </>
                                )}
                                <span className="ml-2">{nextVestingWithdrawString}</span>
                                </div>

                                <div className="sp-stats-row mt-1">
                                    <div className="sp-stat-pill usd">
                                        <i className="fas fa-dollar-sign" /> {numberWithCommas(pd_usd.toFixed(2))}
                                    </div>
                                </div>
                            </div> 
                            <button className="btn btn-speem outline-gray text-muted" style={{minWidth:"105px", whiteSpace: "nowrap"}} onClick={()=> {
                                setCancelPD(true);
                                togglePowerDownModal();
                            }}>
                                <i className="fas fa-xmark" /> Cancel
                            </button> 
                            
                        </div>
                    </div>
                </div>
            )} 
            {withdraw_savings_requests.length > 0 && (
                <>
                    {withdraw_savings_requests.map((request, index) => { 
                        let withdraw_amount = parseFloat(request.amount);
                        let withdraw_currency = request.amount.includes("STEEM")? "STEEM":"SBD";
                        let withdraw_amount_usd = (withdraw_currency == "STEEM")? withdraw_amount * currentSteemPrice: withdraw_amount * currentSBDPrice;
                        let nextSavingsWithdrawString = getRemainingTime(request.complete);
                        return (
                            <div key={`${request.request_id}-${index}`} className="col-12 p-2" >
                                <div className="outline-yellow balance-content p-3">  
                                    <div className="balance-content-value balance-claim-row ">
                                        <div className="balance-claim-info">
                                            <div className="balance-amount">
                                            You are withdrawing funds from savings:  
                                            <span className="ml-2 balance-number">
                                                {numberWithCommas(withdraw_amount.toFixed(3))}
                                            </span>
                                            <span className="balance-currency"> {withdraw_currency}</span>  
                                            <span className="ml-2">{nextSavingsWithdrawString}</span>
                                            </div>

                                            <div className="sp-stats-row mt-1">
                                                <div className="sp-stat-pill usd">
                                                    <i className="fas fa-dollar-sign" /> {numberWithCommas(withdraw_amount_usd.toFixed(2))}
                                                </div>
                                            </div>
                                        </div> 
                                        <button className="btn btn-speem outline-gray text-muted" style={{minWidth:"105px", whiteSpace: "nowrap"}} onClick={()=> {
                                            setRequestIdToCancel(request.request_id);
                                            toggleCancelWithdrawFromSavingsModal();
                                        }}>
                                            <i className="fas fa-xmark" /> Cancel
                                        </button> 
                                        
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </>
                
            )} 
            <TransferModal
                key={`${transferSymbol}-transfer`}
                isShowing={isOpenTransferModal}
                hide={toggleTransferModal}
                symbol={transferSymbol}
                userDirectories={userDirectories}
                initialTo={urlTo}
                initialAmount={urlAmount}
                initialMemo={urlMemo}
                autoConfirm={urlAutoConfirm}
                onSuccess={()=> {
                    getUserDirectories();
                    dispatch(fetchUser(username, false));
                    setTimeout(() => {
                        dispatch(fetchUser(username, false));
                    }, 3000); 
                    setUrlAutoConfirm(false);
                }}
            />
            <TransferToSavingsModal
                key={`${transferSymbol}-transfertosavings`}
                isShowing={isOpenTransferToSavingsModal}
                hide={toggleTransferToSavingsModal}
                symbol={transferSymbol}
                onSuccess={()=> {
                    dispatch(fetchUser(username, false));
                    setTimeout(() => {
                        dispatch(fetchUser(username, false));
                    }, 3000); 
                }}
            />
            <WithdrawFromSavingsModal
                key={`${transferSymbol}-transferfromsavings`}
                isShowing={isOpenWithdrawFromSavingsModal}
                hide={toggleWithdrawFromSavingsModal}
                symbol={transferSymbol}
                onSuccess={()=> {
                    dispatch(fetchUser(username, false));
                    setTimeout(() => {
                        dispatch(fetchUser(username, false));
                    }, 3000); 
                }}
            />
            <CancelWithdrawFromSavingsModal
                key={`${transferSymbol}-canceltransferfromsavings`}
                isShowing={isOpenCancelWithdrawFromSavingsModal}
                hide={toggleCancelWithdrawFromSavingsModal}
                request_id={requestIdToCancel}
                onSuccess={()=> {
                    dispatch(fetchUser(username, false));
                    setTimeout(() => {
                        dispatch(fetchUser(username, false));
                    }, 3000); 
                }}
            />
            <TransferToVestingModal 
                isShowing={isOpenTransferToVestingModal}
                hide={toggleTransferToVestingModal}
                initialTo={urlTo}
                initialAmount={urlAmount}
                autoConfirm={urlAutoConfirm}
                // symbol={transferSymbol}
                onSuccess={()=> {
                    dispatch(fetchUser(username, false));
                    setTimeout(() => {
                        dispatch(fetchUser(username, false));
                    }, 3000); 
                    setUrlAutoConfirm(false);
                }}
            />
            <DelegateModal 
                isShowing={isOpenDelegateModal}
                hide={toggleDelegateModal}
                mvest={mvest}
                outgoing_delegations={userData?.outgoing_delegations || []}
                initialTo={urlTo}
                initialAmount={urlAmount}
                autoConfirm={urlAutoConfirm}
                onSuccess={()=> {
                    dispatch(fetchUser(username, false));
                    setTimeout(() => {
                        dispatch(fetchUser(username, false));
                    }, 3000); 
                    setUrlAutoConfirm(false);
                }}
            />
            <PowerDownModal 
                key={cancelPD? "cancel-pd-"+user:"pd-"+user}
                isShowing={isOpenPowerDownModal}
                hide={togglePowerDownModal}
                mvest={mvest}
                cancel={cancelPD} 
                onSuccess={()=> {
                    dispatch(fetchUser(username, false));
                    setTimeout(() => {
                        dispatch(fetchUser(username, false));
                    }, 3000); 
                }}
            />
            <GenerateLinkModal
                isShowing={isOpenGenerateLinkModal}
                hide={toggleGenerateLinkModal}
                initialOperation={urlOp}
                initialCurrency={transferSymbol}
            />

            <UserHistorySection username={username!} />

            </>
        ); 
    }
    
    const downloadFile = (filename: string, content: string) => {
        const element = document.createElement("a");
        const file = new Blob([content], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = filename;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    const downloadLoginFile = (key: string) => {
        let content = `Speem Account Login File\n`;
        content += `Username: ${username}\n`;
        content += `Posting: ${key}\n`;
        downloadFile(`Steem login for @${username}.txt`, content);
    }

    const downloadFullKeysFile = (keys: any, master: string) => {
        let content = `Speem Account Details\n`;
        content += `Username: ${username}\n`;
        content += `Master Password: ${master}\n\n`;
        content += `============= PRIVATE KEYS =============\n`;
        content += `Owner:   ${keys.owner}\n`;
        content += `Active:  ${keys.active}\n`;
        content += `Posting: ${keys.posting}\n`;
        content += `Memo:    ${keys.memo}\n\n`;
        content += `============= PUBLIC KEYS =============\n`;
        content += `Owner:   ${keys.ownerPubkey}\n`;
        content += `Active:  ${keys.activePubkey}\n`;
        content += `Posting: ${keys.postingPubkey}\n`;
        content += `Memo:    ${keys.memoPubkey}\n`;
        downloadFile(`Steem keys for @${username}.txt`, content);
    }

    const handleRevealFullKeys = () => {
        if (!masterPass) {
            toast({ title: "Error", description: "Please enter your Master Password.", variant: "rose_red" });
            return;
        }

        try {
            const keys: any = {};
            const roles: ('owner' | 'active' | 'posting' | 'memo')[] = ['owner', 'active', 'posting', 'memo'];
            roles.forEach((role) => {
                keys[role] = PrivateKey.fromLogin(username!, masterPass, role).toString();
                keys[`${role}Pubkey`] = PrivateKey.from(keys[role]).createPublic().toString();
            });

            // Verify against public keys if available
            const blockchainPostingPub = userData.posting.key_auths[0][0];
            const blockchainActivePub = userData.active.key_auths[0][0];

            if (keys.postingPubkey === blockchainPostingPub || keys.activePubkey === blockchainActivePub) {
                setFullKeysData(keys);
                setShowFullKeys(true);
                toast({ title: "Success", description: "Keys revealed and verified.", variant: "wild_green" });
            } else {
                toast({ title: "Error", description: "Invalid Master Password. Keys do not match account on blockchain.", variant: "rose_red" });
            }
        } catch (e) {
            toast({ title: "Error", description: "Error generating keys. Check your password.", variant: "rose_red" });
        }
    }

    const generateNewPassword = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
        let password = 'P';
        for (let i = 0; i < 52; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCpNewPass(password);
        setCpConfirmPass("");
        setCpGenerated(password);
    };

    const handleChangePassword = async () => {
        if (!cpCurrentPass) {
            toast({ title: "Error", description: "Please enter your current password.", variant: "rose_red" }); return;
        }
        if (!cpNewPass || cpNewPass !== cpConfirmPass) {
            toast({ title: "Error", description: "New passwords do not match.", variant: "rose_red" }); return;
        }
        if (!cpChecked || !cpSaved) {
            toast({ title: "Error", description: "Please confirm you have saved the new password.", variant: "rose_red" }); return;
        }
        setCpLoading(true);
        try {
            // Detect if cpCurrentPass is a raw WIF (starts with 5/K/L, 51+ chars)
            const isWif = /^[5KL][1-9A-HJ-NP-Za-km-z]{50,}$/.test(cpCurrentPass);
            let ownerWif: string;
            if (isWif) {
                ownerWif = cpCurrentPass;
            } else {
                // Master password — derive the owner private key the same way steem generates it
                ownerWif = PrivateKey.fromSeed(`${username}owner${cpCurrentPass}`).toString();
            }

            // Verify current owner key matches blockchain
            const ownerPub = PrivateKey.from(ownerWif).createPublic().toString();
            const blockchainOwnerPub = userData.owner.key_auths[0][0];
            if (ownerPub !== blockchainOwnerPub) {
                toast({ title: "Wrong Password", description: "Current password does not match account owner key on blockchain.", variant: "rose_red" });
                setCpLoading(false);
                return;
            }

            const result = await changePasswordWithWif(
                username!,
                ownerWif,
                cpNewPass,
                userData.json_metadata || ""
            );

            if (result.success) {
                toast({ title: "Password Changed!", description: "Your account keys have been updated on the blockchain. Please login with your new keys.", variant: "wild_green" });
                setCpCurrentPass(""); setCpNewPass(""); setCpConfirmPass("");
                setCpChecked(false); setCpSaved(false); setCpGenerated("");
            } else {
                toast({ title: "Error Changing Password", description: result.message, variant: "rose_red" });
            }
        } catch (e: any) {
            toast({ title: "Error Changing Password", description: e?.message || String(e), variant: "rose_red" });
        } finally {
            setCpLoading(false);
        }
    };

    const renderChangePasswordSection = () => (
        <Card className="item-speem mt-0" style={{borderTop: '3px solid #e74c3c'}}>
            <CardBody>
                <h4 className="card-title" style={{color: '#e74c3c'}}>
                    <i className="fas fa-lock mr-2" /> Change Account Password
                </h4>
                <p className="text-muted small">
                    This will update all your Steem keys (Owner, Active, Posting, Memo) on the blockchain. 
                    You must have your current <strong>Owner Key or Master Password</strong> to proceed.
                </p>
                <Alert color="danger" className="small">
                    <i className="fas fa-exclamation-triangle mr-2" />
                    <strong>Warning:</strong> This is an irreversible action. Make sure to download and save your new keys before confirming.
                </Alert>
                <div className="row">
                    <div className="col-md-6">
                        <FormGroup>
                            <Label>Current Master Password or Owner Key</Label>
                            <div className="input-icon-group">
                                <i className="fas fa-key input-icon" />
                                <Input type="password" placeholder="Current password / owner key" value={cpCurrentPass}
                                    onChange={(e) => setCpCurrentPass(e.target.value)} className="fancy-input" />
                            </div>
                        </FormGroup>
                    </div>
                    <div className="col-md-6">
                        <FormGroup>
                            <Label>New Master Password</Label>
                            <div className="d-flex gap-2 align-items-center">
                                <div className="input-icon-group flex-grow-1">
                                    <i className="fas fa-lock input-icon" />
                                    <Input type="text" placeholder="New password (or generate one)" value={cpNewPass}
                                        onChange={(e) => { setCpNewPass(e.target.value); setCpGenerated(""); }}
                                        className="fancy-input" style={{fontFamily: 'monospace', fontSize: '12px'}} />
                                </div>
                                <Button color="secondary" outline size="sm" onClick={generateNewPassword} style={{whiteSpace:'nowrap'}}>
                                    <i className="fas fa-dice mr-1" /> Generate
                                </Button>
                            </div>
                        </FormGroup>
                    </div>
                    {cpGenerated && (
                        <div className="col-12">
                            <Alert color="warning" className="small">
                                <i className="fas fa-key mr-2" />
                                <strong>Generated Password (copy this!):</strong>
                                <code className="d-block mt-1" style={{wordBreak:'break-all', fontSize:'13px'}}>{cpGenerated}</code>
                            </Alert>
                        </div>
                    )}
                    <div className="col-md-6">
                        <FormGroup>
                            <Label>Confirm New Password</Label>
                            <div className="input-icon-group">
                                <i className="fas fa-lock input-icon" />
                                <Input type="password" placeholder="Re-enter new password" value={cpConfirmPass}
                                    onChange={(e) => setCpConfirmPass(e.target.value)} className="fancy-input"
                                    style={{borderColor: cpConfirmPass && cpConfirmPass !== cpNewPass ? '#e74c3c' : undefined}} />
                            </div>
                            {cpConfirmPass && cpConfirmPass !== cpNewPass && (
                                <small className="text-danger">Passwords do not match.</small>
                            )}
                        </FormGroup>
                    </div>
                </div>
                <FormGroup check className="mt-2">
                    <Label check>
                        <input type="checkbox" checked={cpChecked} onChange={(e) => setCpChecked(e.target.checked)} className="mr-2" />
                        I understand this will replace all my current keys and I cannot recover them without the new password.
                    </Label>
                </FormGroup>
                <FormGroup check className="mt-2">
                    <Label check>
                        <input type="checkbox" checked={cpSaved} onChange={(e) => setCpSaved(e.target.checked)} className="mr-2" />
                        I have saved my new Master Password in a secure place.
                    </Label>
                </FormGroup>
                <div className="mt-4">
                    <Button color="danger" className="w-100" onClick={handleChangePassword}
                        disabled={cpLoading}>
                        {cpLoading ? <span className="spinner dark m-0 mr-2" /> : <i className="fas fa-rotate mr-2" />}
                        {cpLoading ? 'Updating keys on blockchain...' : 'Change Password & Update Keys'}
                    </Button>
                </div>
            </CardBody>
        </Card>
    );

    const renderKeys = () => {
        if (user !== username) {
            return <div className="text-center w-100 p-5"><strong>You can only manage keys for your own account.</strong></div>;
        }

        const sessionData = autologin ? extractSessionData(autologin) : null;
        const sessionKey = sessionData ? sessionData[1] : null;
        
        let sessionKeyType = keychainLogin ? "Keychain" : "Unknown";
        if (sessionKey && userData) {
            try {
                const pub = PrivateKey.from(sessionKey).createPublic().toString();
                if (pub === userData.posting.key_auths[0][0]) sessionKeyType = "Posting";
                else if (pub === userData.active.key_auths[0][0]) sessionKeyType = "Active";
                else if (pub === userData.owner.key_auths[0][0]) sessionKeyType = "Owner";
            } catch (e) {}
        }

        return (
            <div className="col-12 p-3">
                <div className="row">
                    <div className="col-md-6 mb-4">
                        <Card className="item-speem h-100">
                            <CardBody>
                                <h4 className="card-title"><i className="fas fa-id-card mr-2" /> Current Session</h4>
                                <p className="text-muted small">This is the key you are currently using to browse and interact.</p>
                                <FormGroup>
                                    <Label>Session Key ({sessionKeyType})</Label>
                                    <div className="input-icon-group">
                                        <i className="fas fa-key input-icon" />
                                        <Input 
                                            type="password" 
                                            value={sessionKey || "Keychain (No local key)"} 
                                            readOnly 
                                            className="fancy-input"
                                        />
                                    </div>
                                </FormGroup>
                                {sessionKey && (
                                    <Button color="info" outline className="w-100" onClick={() => downloadLoginFile(sessionKey)}>
                                        <i className="fas fa-file-download mr-2" /> Download Login File (.txt)
                                    </Button>
                                )}
                            </CardBody>
                        </Card>
                    </div>

                    <div className="col-md-6 mb-4">
                        <Card className="item-speem h-100">
                            <CardBody>
                                <h4 className="card-title text-warning"><i className="fas fa-shield-alt mr-2" /> Full Account Access</h4>
                                <p className="text-muted small">Reveal all your private keys using your Master Password.</p>
                                {!showFullKeys ? (
                                    <>
                                        <FormGroup>
                                            <Label>Master Password</Label>
                                            <Input 
                                                type="password" 
                                                placeholder="Enter Master Password to reveal keys" 
                                                value={masterPass}
                                                onChange={(e) => setMasterPass(e.target.value)}
                                                className="fancy-input"
                                            />
                                        </FormGroup>
                                        <Button color="warning" outline className="w-100" onClick={handleRevealFullKeys}>
                                            <i className="fas fa-eye mr-2" /> Reveal & Verify Keys
                                        </Button>
                                    </>
                                ) : (
                                    <div className="mt-2">
                                        <Alert color="success" className="p-2 small"> Keys verified against blockchain.</Alert>
                                        <div className="mb-3">
                                            <FormGroup className="mb-2">
                                                <Label className="small mb-1">Posting Key</Label>
                                                <div className="input-icon-group">
                                                    <i className="fas fa-lock input-icon" />
                                                    <Input type="text" value={fullKeysData.posting} readOnly className="fancy-input" style={{fontSize: '0.8rem'}} />
                                                </div>
                                            </FormGroup>
                                            <FormGroup className="mb-2">
                                                <Label className="small mb-1">Active Key</Label>
                                                <div className="input-icon-group">
                                                    <i className="fas fa-lock input-icon" />
                                                    <Input type="text" value={fullKeysData.active} readOnly className="fancy-input" style={{fontSize: '0.8rem'}} />
                                                </div>
                                            </FormGroup>
                                            <FormGroup className="mb-2">
                                                <Label className="small mb-1">Owner Key</Label>
                                                <div className="input-icon-group">
                                                    <i className="fas fa-lock input-icon" />
                                                    <Input type="text" value={fullKeysData.owner} readOnly className="fancy-input" style={{fontSize: '0.8rem'}} />
                                                </div>
                                            </FormGroup>
                                            <FormGroup className="mb-2">
                                                <Label className="small mb-1">Memo Key</Label>
                                                <div className="input-icon-group">
                                                    <i className="fas fa-lock input-icon" />
                                                    <Input type="text" value={fullKeysData.memo} readOnly className="fancy-input" style={{fontSize: '0.8rem'}} />
                                                </div>
                                            </FormGroup>
                                        </div>
                                        <Button color="success" outline className="w-100" onClick={() => downloadFullKeysFile(fullKeysData, masterPass)}>
                                            <i className="fas fa-file-export mr-2" /> Download Full Keys (.txt)
                                        </Button>
                                        <Button color="link" size="sm" className="w-100 mt-2 text-muted" onClick={() => setShowFullKeys(false)}>
                                            Hide keys
                                        </Button>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </div>
                </div>
                
                <Alert color="info" className="mt-2">
                    <i className="fas fa-info-circle mr-2" />
                    <strong>Tip:</strong> The <strong>Login File</strong> contains only your Posting key. It's safer to use for daily login on Speak on Steem.
                </Alert>

                <div className="mt-4">
                    {renderChangePasswordSection()}
                </div>
            </div>
        );
    }
    
    
 
    if (error) {
        console.log(error);
        toast({
            title: "Error",
            description: error,
            variant:"rose_red"
        });  
    }
    if (errorMessage) {
        console.log(errorMessage);
        toast({
            title: "Error",
            description: errorMessage,
            variant:"rose_red"
        }); 
    }

    return (
        <div className="user-settings mt-2 container-fluid"> 
        <SEO 
            title={(profileData.name || "") +" - Speak on Steem"}
            description={profileData.about}
            image={profileData.avatar}
            type="profile"
            author={username}
        />
        {!user ?( 
            <div className="scroll-content">
                <div className={`screen`}>
                    <h1 className="typing">Welcome to Speak on Steem!</h1>
                    <p className="typing delay-1">Log in to see your Steem Wallet.</p> 
                    <> 
                        <button type="button" className="btn btn-speem" onClick={toggleLoginModal}>
                            <i className="fas fa-user" /> Login 
                        </button>
                    </> 
                </div> 
            </div>
        ):(
            <React.Fragment>
                <div className="card-stats card item-speem mb-0">
                    {userCover && userCover}
                    <div className="card-body pb-0" style={{marginTop:(userCover)?"-100px":""}}>
                        {(isLoading  && !userData) ? (
                            <div className="text-center w-100">
                                <span className="spinner dark" />
                            </div>
                        ) : (
                            <>
                            {profileHeader} 
                            </>
                        )}
                        
                    </div>
                </div>  
                <div className="p-0 mb-2">
                    <div className="container-fluid p-0">
                        <div className="col-12 p-0">
                            <div className="menu-tabs">
                                <button className={`tab-button ${activeTab === 'balance' ? 'active' : ''}`} onClick={() => handleTabChange('balance')} title="Balance">
                                    <i className="fas fa-wallet" /> <span className="d-none d-md-inline ml-1">Balance</span>
                                </button>
                                <button className={`tab-button ${activeTab === 'market' ? 'active' : ''}`} onClick={() => handleTabChange('market')} title="Market">
                                    <i className="fas fa-chart-line" /> <span className="d-none d-md-inline ml-1">Market</span>
                                </button>
                                {user == username && (
                                    <button className={`tab-button ${activeTab === 'keys' ? 'active' : ''}`} onClick={() => handleTabChange('keys')} title="Keys & Security">
                                        <i className="fas fa-key" /> <span className="d-none d-md-inline ml-1">Keys & Security</span>
                                    </button>
                                )}
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="row p-0 m-0"> 
                    
                    {(() => {
                        let section;
                        switch (activeTab) {
                            case "balance":
                                section = renderBalances();
                                break;
                            case "market":
                                section = <div className="col-12 p-0"><UserMarketTab 
                                    steemBalance={parseFloat(userData?.balance) || 0}
                                    sbdBalance={parseFloat(userData?.sbd_balance) || 0}
                                    onBalanceRefresh={() => username && dispatch(fetchUser(username, false))}
                                /></div>;
                                break;
                            case "keys":
                                section = renderKeys();
                                break;
                            default:
                                section = renderBalances();
                                break;
                        }
                        return section;
                    })()} 
                </div> 
            </React.Fragment>
        )}
            <LoginModal
                isShowing={isOpenLoginModal}
                hide={toggleLoginModal}
            />
        </div>
    );
}; 